/* eslint-disable no-return-assign */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import ViewHistoryModal from '../components/history/modals/ViewHistoryModal';

function ViewTaxDeclarationModal({ data, type }) {
  const setModal = useContext(ModalContext);
  const [iframeKey, setIframeKey] = useState(1);

  const handleOnViewHistory = e => {
    e.preventDefault();
    setModal({
      title: "View History",
      isOpen: true,
      content: <ViewHistoryModal dataInfo={data} />,
      modalSize: 'modal-lg',
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const replaceId = {
    '{id}': _.get(data, 'attributes.rptax_building_application_id'),
    '{historyId}': _.get(data, 'id'),
  };

  const url =
    type === 'history'
      ? c.TAX_DECLARATION_HISTORY_URL.replace(/{id}|{historyId}/gi, (match) => {
        return replaceId[match];
      })
      : c.TAX_DECLARATION_URL.replace('{id}', _.get(data, 'id'));

  const src = `${process.env.REACT_APP_WS
    }${url}?bearer_token=${token}&email=${_.get(authProfile, 'email')}`;

  useEffect(() => {
    setIframeKey(_.random(1, 1000));
  }, []);

  return (
    <Modal.Body>
      {type === 'history' && (
        <button onClick={handleOnViewHistory} type="button" className="btn btn-link">
          <i className="fas fa-chevron-left back-login" /> Back
        </button>
      )}
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  key={iframeKey}
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="FAAS"
                  src={src}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewTaxDeclarationModal.defaultProps = {
  data: {},
  type: '',
};

ViewTaxDeclarationModal.propTypes = {
  data: PropTypes.instanceOf(Object),
  type: PropTypes.string,
};

const mapStateToProps = () => { };

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewTaxDeclarationModal);
